const POD = 'pod';
const CSV = 'csv';
const DONE = 'DONE';
const DONE_WITHOUT_MANIFEST = 'DONE_WITHOUT_MANIFEST';
const DONE_WITH_CANCELLATIONS = 'DONE_WITH_CANCELLATIONS';
const CANCELLED = 'CANCELLED';

export default {
  POD,
  CSV,
  DONE,
  DONE_WITHOUT_MANIFEST,
  DONE_WITH_CANCELLATIONS,
  CANCELLED,
};
